export default "__VITE_ASSET__B4HpX8cv__"